import { render, staticRenderFns } from "./cancer.vue?vue&type=template&id=aacf726a&"
import script from "./cancer.vue?vue&type=script&lang=js&"
export * from "./cancer.vue?vue&type=script&lang=js&"
import style0 from "./cancer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports